export enum OrderingType {
  MIN_PRICE = 'MIN_PRICE',
  MAX_PRICE = 'MAX_PRICE',
  BEST_REVIEW = 'BEST_REVIEW',
  ALPHABETIC = 'ALPHABETIC',
  POPULAR = 'POPULAR'
}
